import { createBrowserHistory } from 'history';
import * as React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import configureStore from '../configureStore';
import { ApiTokenHandler } from '../data/apiClient/apiConfig';
import { Tbody } from '../data/quotes/quotesModels';
import RoutesModule from '../routes';
import './App.css';

/*tslint:diable*/
// Create browser history to use in the Redux store
const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = {
    news: {
        thenews: [],
        loading: false,
        internalnews: [],
        loadinginternal: false
    },
    header: {
        bottomHeader: 'My Quick Solutions Online'
    },
    quotes: {
        myQuotes: new Array<Tbody>()
    },
    user: {
        permissions: {
            duct: {
                create: false,
                read: false,
                update: false
            },
            invoices: {
                create: false,
                read: false,
                update: false
            },
            news: {
                create: false,
                read: false,
                update: false
            },
            opportunities: {
                create: false,
                read: false,
                update: false
            },
            orders: {
                create: false,
                read: false,
                update: false
            },
            quickTickOnline: {
                create: false,
                read: false,
                update: false
            },
            resourceTraining: {
                create: false,
                read: false,
                update: false
            },
            fullAccess: {
                create: false,
                read: false,
                update: false
            },
            qfv: {
                create: false,
                read: false,
                update: false
            },
            error: false
        },
        firstName: '',
        lastName: '',
        token: 'no token',
        name: 'John Smith',
        contactEmailAddress: '',
        crmUserId: '',
        error: false,
        errorMessage: '',
        CustomerInformation: {
            salesCurentYearToDate: 0,
            salesPreviousYear: 0,
            salesPreviousYearToDate: 0,
            ranking: -1,
            territoryName: ''
        }
    },
    order: {
        orders: [],
        order: undefined,
        loading: false
    },
    invoices: {
        invoices: [],
        loading: false
    },
    projects: {
        projects: [],
        loading: false
    },
    opportunities: {
        opportunities: [],
        loading: false
    },
    shipments: {
        shipments: [],
        loading: false
    }
};
const store = configureStore(history, initialState);

interface AppProps {
    token: string;
    userName: string;
}

class App extends React.Component<AppProps, {}> {
    constructor(props: AppProps) {
        super(props);
    }

    componentWillMount() {
        ApiTokenHandler.Token = this.props.token;
        store.dispatch({ type: 'SET_TOKEN', data: this.props.token });
    }

    componentDidMount() {
        let name: string;
        name = this.props.userName;
        store.dispatch({ type: 'SET_USER_NAME', data: name });
    }

    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history} children={RoutesModule} />
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.tsx